import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  updatePolicy,
  updatePolicyContactDetails,
  requestPolicy,
  updateValidation,
  updateReasonForTempcover,
  initPolicyConfirmationPage,
  updateAnalysisData,
} from './actions'

import { REASON_FOR_PURCHASE_OPTIONS } from './constants'
import { updateStep } from '../App/actions'
import { MainHeading, SectionSpacing, HeadingContainer } from './styles.js'
import LoadingScreen from '../../components/LoadingScreen'
import { PRIVATE_CAR, COMMERCIAL_VEHICLE } from '../Vehicle/constants'
import GapActivationConfirmation from '../../components/GapActivationConfirmation'
import AnnualUpsell from '../AnnualUpsell'
import GridContainerWrapper from 'components/@common/GridContainerWrapper'
import MentionMe from 'containers/MentionMe'
import { withOptimizely } from '@optimizely/react-sdk'
import { PolicyDocuments } from './Sections/PolicyDocuments'
import { MobileAppBanner } from './Sections/MobileAppBanner'
import { Card } from 'components/@common/Card'
import PriceDetails from 'components/DriverDetailsCard/components/PriceDetails'
import { PolicyDetails } from './Sections/PolicyDetails'

/* eslint-disable react/prefer-stateless-function */
export class PolicyConfirmationPage extends React.Component {
  constructor(props) {
    super(props)
    this.handleSelect = this.handleSelect.bind(this)
    this.updateReasonForTempcover = this.updateReasonForTempcover.bind(this)

    this.state = {
      selectedOption: null,
    }
  }

  componentDidMount = () => {
    const { optimizely } = this.props
    if (optimizely) {
      optimizely.onReady().then(() => {
        optimizely.track('purchase')
      })
    }

    if (!window.isHoldingPageOn) {
      this.props.actions.initPolicyConfirmationPage()
    }
  }

  handleSelect = (event) => {
    var index = event.nativeEvent.target.selectedIndex
    this.setState({
      selectedOption: {
        value: event.target.value,
        description: event.nativeEvent.target[index].text,
      },
    })
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.policy.reasonForCover !== prevProps.policy.reasonForCover) {
      window.dataLayer.push({
        event: 'reasonForCover',
        policyConfirmationDataLayerPushEvent: [
          {
            reasonForCover: this.props.policy.reasonForCover.description,
          },
        ],
      })
    }
  }

  updateReasonForTempcover() {
    this.props.actions.updateReasonForTempcover(this.state.selectedOption)
  }

  handleReasonForCoverOptions() {
    return REASON_FOR_PURCHASE_OPTIONS.map((option) => (
      <option key={option.id} value={option.value} selected={option.selected}>
        {option.description}
      </option>
    ))
  }

  render() {
    const { value: licenceType } = this.props.riskData.LicenceType
    const isProvisional = licenceType === 'ProvisionalUkLicence'

    return (
      <>
        {this.props.loading ? (
          <LoadingScreen message='Generating your documents' />
        ) : (
          <GridContainerWrapper>
            <SectionSpacing>
              <HeadingContainer>
                <MainHeading>You're covered!</MainHeading>
                <p>We've emailed your policy documents to you.</p>
              </HeadingContainer>
              <Card>
                <PriceDetails style={{ justifyContent: 'center' }} />
                <PolicyDetails policyId={this.props.policy.PolicyId} />
              </Card>
              {!this.props.affiliate.AffiliateId &&
                !isProvisional &&
                !this.props.riskData.Impounded &&
                [PRIVATE_CAR, COMMERCIAL_VEHICLE].includes(
                  this.props.vehicle.selected.VehicleType,
                ) && <MobileAppBanner />}
              <Card>
                <PolicyDocuments
                  policyDocuments={this.props.policy.PolicyDocuments}
                  quoteId={this.props.riskData.QuoteId}
                />
              </Card>
              <MentionMe
                customerId={this.props.riskData.CustomerId}
                forename={this.props.riskData.Forename}
                surname={this.props.riskData.Surname}
                email={this.props.riskData.EmailAddress}
                price={this.props.price.TotalPrice.toFixed(2)}
              />
              <GapActivationConfirmation
                encyrptedQuoteId={this.props.riskData.QuoteId}
              />
              <AnnualUpsell />
              <br />
            </SectionSpacing>
          </GridContainerWrapper>
        )}
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    policy: state.policy,
    riskData: state.riskData,
    address: state.address,
    price: state.price,
    vehicle: state.vehicle,
    affiliate: state.affiliate,
    loading: state.isLoading,
    scheme: state.scheme.selected,
    features: state.features || {},
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        updatePolicy,
        updatePolicyContactDetails,
        updateValidation,
        requestPolicy,
        updateReasonForTempcover,
        initPolicyConfirmationPage,
        updateStep,
        updateAnalysisData,
      },
      dispatch,
    ),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withOptimizely(PolicyConfirmationPage))
